<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>{{ $tc('general.n0') }}</th>
          <th>{{ $tc('tournament.competitors', 2) }}</th>
          <th>{{ $tc('general.type') }}</th>
          <th v-if="showClubName">{{ $tc('club.club_name') }}</th>
          <th>{{ $tc('settings.discipline') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(registration, index) in data" :key="registration.id">
          <td>{{ index + 1 }}.</td>
          <td>{{ getCompetitorNames(registration) }}</td>
          <td>{{ registration.type | teamType }}</td>
          <td v-if="showClubName">{{ registration.club.shortName }}</td>
          <td>
            <div
              v-for="(item, index) in getDisciplinesDataList(registration.categories)"
              :key="index"
              class="data-list-item">
              <div v-if="item.label" class="label">{{ item.label }}</div>
              <div v-if="item.text" class="text">{{ item.text }}</div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: null
    },

    showClubName: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    getCompetitorNames (item) {
      const keys = ['competitor', 'competitorTwo', 'competitorThree', 'competitorFour']
      const assignedNumbers = {
        competitor: item.competitorAssignedNumber,
        competitorTwo: item.competitorTwoAssignedNumber,
        competitorThree: item.competitorThreeAssignedNumber,
        competitorFour: item.competitorFourAssignedNumber
      }
      const competitors = keys.map(key => item[key] && ({
        ...item[key],
        assignedNumber: assignedNumbers[key]
      })).filter(item => !!item).map((competitor) => {
        return `${competitor.assignedNumber ? `#${competitor.assignedNumber}` : ''} ${competitor.firstName} ${competitor.lastName} (${competitor.isMale ? 'M' : 'Ž'})`
      })

      return competitors.join(', ')
    },

    getDisciplinesDataList (categories) {
      return categories?.reduce((acc, item) => {
        acc.push({ label: item.category?.name })
        const discplines = item.disciplines?.map(disc => ({ text: disc.discipline.name }))
        acc.push(...discplines)
        return acc
      }, [])
    }
  }
}
</script>
